module.exports = __webpack_public_path__ + "static/1t-69a2ce555d098cafb30a04feb3084123.webp";